export const DURATION_UNITS = [
  { value: "day", label: "يوم" },
  { value: "days", label: "أيام" },
  { value: "week", label: "أسبوع" },
  { value: "weeks", label: "أسابيع" },
  { value: "month", label: "شهر" },
  { value: "months", label: "أشهر" },
];
export const FREQUENCIES = [
  { value: "once_daily", label: "مرة يومياً" },
  { value: "bid", label: "مرتين يومياً" },
  { value: "tid", label: "ثلاث مرات يوميا" },
  { value: "qid", label: "كل 6 ساعات" },
  { value: "q8h", label: "كل 8 ساعات" },
  { value: "q12hrs", label: "كل 12 ساعة" },
  { value: "q24hrs", label: "كل 24 ساعة" },
  { value: "q36hrs", label: "كل 36 ساعة" },
  { value: "every_other_day", label: "يوم بعد يوم" },
  { value: "q48hrs", label: "كل 48 ساعة" },
  { value: "weekly", label: "مرة أسبوعياً" },
  { value: "monthly", label: "مرة شهرياً" },
];
export const DOSE_UNITS = [
  { value: "ml", label: "ملل" },
  { value: "tsp", label: "ملعقة صغيرة" },
  { value: "tbsp", label: "ملعقة كبيرة" },

  { value: "tablet", label: "قرص" },
  { value: "capsule", label: "كبسولة" },
  { value: "sachet", label: "كيس" },

  { value: "drop", label: "نقطة" },
  { value: "puff", label: "بخة" },
  { value: "spray", label: "رشّة" },

  { value: "0.1ml", label: "شرطة أنسولين" },
  { value: "ampule", label: "أمبولة" },
  { value: "vial", label: "فيال" },
  { value: "syringe", label: "حقنة" },

  { value: "patch", label: "لاصقة" },
  { value: "application", label: "مرة دهان" },
];

export const MEDICATION_ROUTES = [
  { value: "oral", label: "بالفم" },
  { value: "sublingual", label: "تحت اللسان" },

  { value: "iv", label: "حقن بالوريد" },
  { value: "im", label: "حقن بالعضل" },
  { value: "sc", label: "حقن تحت الجلد" },

  { value: "transdermal", label: "لاصقة جلدية" },
  { value: "topical", label: "دهان خارجي" },
  { value: "oral_rinse", label: "مضمضة / غسول فم" },

  { value: "nebulization", label: "جلسة بخار" },
  { value: "inhalation", label: "استنشاق" },

  { value: "rectal", label: "لبوس شرجي" },
  { value: "vaginal", label: "لبوس مهبلي" },

  { value: "eye_drop", label: "نقط بالعين" },
  { value: "ear_drop", label: "نقط بالأذن" },
  { value: "nasal_drop", label: "نقط بالأنف" },
  { value: "nasal_spray", label: "بخاخة بالأنف" },
];
